module.exports = __webpack_public_path__ + "img/3-large.c76b768d.jpg";